export default "__VITE_ASSET__CWdkzWax__"